import {
  IconBuildingStore,
  IconCalendar,
  IconHeadset,
  IconHome2,
  IconLogout,
  IconReceipt,
  IconReceiptTax,
  IconSchool,
  IconUser,
  IconUsers
} from '@tabler/icons'
import Link from 'next/link'

import {
  Site as SiteType,
  SiteContext as SiteContextType,
  SiteModule as SiteModuleType
} from '@/types'

export const menuItems = (
  siteData: SiteType,
  activeContext: SiteModuleType | null,
  enrollmentWorkspace: boolean
) =>
  [
    {
      label: 'Minha conta',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconHome2 size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts',
      description: 'Acesse o menu da minha conta.',
      isStaff: false
    },
    {
      label: 'Comprar agora',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconBuildingStore size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts/profiles',
      description: 'Acessar lojas para comprar produtos e serviços.',
      context: 'store' as SiteContextType
    },
    {
      label: 'Cursos',
      active: enrollmentWorkspace,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconSchool size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/courses',
      description: 'Acessar os cursos disponíveis.',
      context: 'enrollment' as SiteContextType
    },
    {
      label: 'Mensalidades',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconCalendar size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts/contract-payments',
      description: 'Pagamentos das mensalidades dos alunos vinculado ao responsável.',
      context: 'enrollment' as SiteContextType
    },
    {
      label: 'Meus pedidos',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconReceipt size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts/orders',
      description: 'Acesse notas fiscais, pagamentos, cancelamento e devolução.',
      context: 'store' as SiteContextType
    },
    {
      label: 'Meus dados',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconUser size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts/profile',
      description: 'Altere e mantenha seus dados atualizados.'
    },
    {
      label: activeContext === 'enrollment' ? 'Matrículas' : 'Meus alunos',
      active:
        activeContext === 'enrollment' ||
        (activeContext === 'store' && siteData?.beneficiary !== 'shopper'),
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconUsers size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts/students',
      description: 'Veja os detalhes das matrículas dos alunos.'
    },
    {
      label: 'Extrato de pagamentos',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconReceiptTax size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts/payment-statement',
      description: 'Veja o extrato de pagamentos realizados em nossa loja.',
      context: 'enrollment' as SiteContextType
    },
    { divider: true },
    { label: 'Site', section: true },
    {
      label: 'Atendimento',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconHeadset size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/help',
      description: undefined
    },
    {
      label: 'Sair',
      active: true,
      disabled: false,
      color: undefined,
      icon: (size: number) => <IconLogout size={size} />,
      rightSection: undefined,
      component: Link,
      href: '/accounts/logout',
      description: undefined
    }
  ].filter(item => !item.context || item.context === activeContext)
